import { useParams } from 'react-router-dom'
import { Button, Group, Stack, Title, Tooltip } from '@mantine/core'
import { OffersList } from '@/components/offers/offers-list/offers-list'
import { SeasonDropdown } from '@shared/components/season-dropdown/season-dropdown'
import { useMemo, useState } from 'react'
import { IconDownload } from '@tabler/icons-react'
import { getSeasonYear } from '@shared/helpers/get-season-year/get-season-year'
import { useOfferCsvDownload } from '@/hooks/use-offer-csv-download'

export function StationOffers() {
  const { stationRecordNumber } = useParams()
  const [seasonStartDate, setSeasonStartDate] = useState<Date | undefined>(undefined)

  const seasonFilterValue: number | undefined = useMemo(
    () => seasonStartDate?.getFullYear(),
    [seasonStartDate]
  )

  const getCsvFilename = () => `${stationRecordNumber}-offers-${getSeasonYear(seasonStartDate)}.csv`

  const { downloadCSV, isDownloading } = useOfferCsvDownload({
    stationRecordNumber,
    seasonFilterValue,
    filename: getCsvFilename(),
  })

  return (
    <Stack>
      <Group>
        <Title order={2} data-testid='station-offers' mr='auto'>
          Station Offers
        </Title>
        <SeasonDropdown
          seasonsBeforeCurrent={5}
          seasonsAfterCurrent={0}
          setSeasonStartDate={setSeasonStartDate}
          setSeasonEndDate={() => undefined} // Season end date is currently not used by this page
          showAllSeasons
        />
        <Tooltip label='Download raw data as CSV. Requires a season to be selected.'>
          <Button
            onClick={downloadCSV}
            leftSection={<IconDownload />}
            disabled={!seasonStartDate}
            loading={isDownloading}
          >
            Download
          </Button>
        </Tooltip>
      </Group>
      <OffersList stationRecordNumber={stationRecordNumber} seasonFilterValue={seasonFilterValue} />
    </Stack>
  )
}
